import { render, staticRenderFns } from "./PackDispatch.vue?vue&type=template&id=460b8aca"
import script from "./PackDispatch.vue?vue&type=script&lang=js"
export * from "./PackDispatch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports